import {Row, Col, Form} from 'react-bootstrap';
import PropTypes from 'prop-types';
import {usePortalContext} from '../../lib/context/portalContext';
import withAlerts from '../../lib/withAlerts';
import {compose} from '../../lib/compose';
import DeleteConfirmModal from '../deleteConfirmModal';
import {useDeviceMutations} from './deviceMutations';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinnerThird} from '@fortawesome/pro-duotone-svg-icons';
import variables from '../../styles/_variables.module.scss';
import {Can} from '../auth/can';


const PhoneBonding = ({alerts = {}}) => {
  const {success, error} = alerts;
  const {unlink} = useDeviceMutations();
  const {rowData, togglePortal} = usePortalContext();
  const {linked_phones, serial_number, device_configuration} = rowData || {};
  const {needs_hdm_unlink} = device_configuration ?? {};
  const { linked_phone_id } = linked_phones?.[0] ?? {};
  
  const handleDeviceUnlink = async () => {

    const unlinkDevice = await unlink({
      variables: {
        serial_number: serial_number
      }
    });

    if(unlinkDevice?.errors) {

      const userFacingError = ('Device unlink scheduling failed.');
      error({msg: userFacingError});
      
    } else {
      success({msg: 'Device successfully scheduled for unlinking.'});
      togglePortal();
      
    }
  };

  return (
    <div className="offcanvas-form" data-testid="offcanvas-safecase">
      {needs_hdm_unlink &&
        <Row>
          <Col className="mb-3">
            <Form.Group>
              <div>Unlinking in progress <FontAwesomeIcon icon={faSpinnerThird} className="fa-spin" color={variables.privoroBlue}/> </div>
            </Form.Group>
          </Col>
        </Row>
      }

      {!linked_phone_id && !needs_hdm_unlink && 
        <Row>
          <Col className="mb-3">
            <Form.Group>
              <div>SafeCase not linked to phone</div>
            </Form.Group>
          </Col>
        </Row>
      }

      {linked_phone_id && !needs_hdm_unlink && 
        <>
          <Row>
            <Col className="mb-3">
              <Form.Group>
                <Form.Label>Linked Phone ID</Form.Label>
                <div>{linked_phone_id}</div>
              </Form.Group>
            </Col>
          </Row>

          {/* RBAC: SAFECASE_UNLINK gates only this Unlink action - viewing
              the Linked Phone ID above stays visible under SAFECASE_VIEW,
              matching the same pattern applied to User/Policy/HDM/SSID. */}
          <Can code="SAFECASE_UNLINK">
            <Row>
              <Col className="mb-3">
                <div className="d-grid gap-2">
                  <DeleteConfirmModal
                    button={true}
                    buttontext="Unlink Phone from SafeCase"
                    onChange={handleDeviceUnlink}
                    title={`Confirm Unlinking`}
                    message={`Are you sure you want to unlink this SafeCase from linked phone id ${linked_phone_id}?`}
                    />
                  </div>
              </Col>
            </Row>
          </Can>
        </>
      }
    </div>
  )
}

export default compose(
  withAlerts,
)(PhoneBonding);
